module.exports = __webpack_public_path__ + "img/matched-ellipse.d59502a.svg";